if (!customElements.get('pudel-faq-topics')) {
  customElements.define('pudel-faq-topics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const list = this.querySelector('.pudel-faq-home__tabs');
      this.tabs = Array.from(this.querySelectorAll('.pudel-faq-home__tab'));
      this.panels = Array.from(this.querySelectorAll('.pudel-faq-home__panel'));
      if (!list || !this.tabs.length) return;
      list.setAttribute('role', 'tablist');
      this.tabs.forEach(tab => {
        tab.setAttribute('role', 'tab');
        const panel = this.panels.find(p => p.dataset.topic === tab.dataset.topic);
        if (!panel.querySelector('details')) { tab.hidden = true; panel.hidden = true; }
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => this.selectTopic(tab));
        tab.addEventListener('keydown', event => {
          const visible = this.tabs.filter(t => !t.hidden);
          const i = visible.indexOf(tab);
          let target;
          if (event.key === 'ArrowRight') target = visible[(i + 1) % visible.length];
          if (event.key === 'ArrowLeft') target = visible[(i - 1 + visible.length) % visible.length];
          if (event.key === 'Home') target = visible[0];
          if (event.key === 'End') target = visible[visible.length - 1];
          if (target) { event.preventDefault(); this.selectTopic(target); target.focus(); }
        });
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('.pudel-faq-home__panel');
        if (!panel) return;
        const tab = this.tabs.find(t => t.dataset.topic === panel.dataset.topic);
        if (tab) this.selectTopic(tab);
        const detail = event.target.closest('details');
        if (detail) detail.open = true;
      });
      this.dataset.enhanced = 'true';
      this.selectTopic(this.tabs.find(t => !t.hidden));
      list.hidden = false;
    }
    selectTopic(selected) {
      if (!selected) return;
      this.tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.topic !== selected.dataset.topic; });
    }
  });
}
